<template>
    <div>
        <ul class="fd-card1-item" v-if="data&&data.length">
            <li class="fd-card1-list" v-for="item in data"  @click="goToDetail(item)">
                <div class="fd-flex ">
                    <div class="fd-card1-title" v-html="'【'+item.xwly+'】'+item.bt"></div>
                    <!--<span class="fd-ajly">案件来源：{{item.ajly}}</span>-->
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <span class="fd-aj-date">{{item.fbsj.slice(0,10)}}</span>
                </div>

<!--                <div class="fd-card1-content" >-->
<!--                    &lt;!&ndash;<span v-text="getMsg(item.content)" class="fd-card1-msg"></span>&ndash;&gt;-->
<!--                    <span class="fd-card1-more">【详情】</span>-->
<!--                </div>-->
            </li>
        </ul>
        <div class="fd-no-result" v-else>
            <p>很抱歉，未找到与“{{search}}”相关的内容</p>
            <div class="fd-small-data">
                <p>温馨提示：</p>
                <p>1.内容正在维护更新中</p>
                <p>2.您可以浏览其他板块页面</p>
            </div>
        </div>
        <!--内容区域 end-->
        <aty-pagination class="fd-mt0"
                        :total="query.total"
                        :limit="query.limit"
                        :offset="query.offset"
                        v-if="data&&data.length"
                        show-total show-elevator
                        @change="pageInformation"
        ></aty-pagination>
    </div>

</template>

<script>
    export default {
        name: 'page-search',
        data() {
            return {
                data:[],
                query:{
                    offset: 0,
                    limit: 10,
                    total: 100
                },
                search:''
            };
        },
        watch:{
            '$route.query.search':{
                handler() {
                    this.search = this.$route.query.search;
                    this.query.limit = 10;//默认第一页
                    this.query.offset = 0;
                    this.searchByKeyword();
                },
                immediate:true
            }
        },
        methods:{
            // 截取信息加'...'
            getMsg(msg) {
                const strLength = 145;
                return msg.length > strLength ? `${msg.substring(0, strLength)}...` : msg;
            },
            searchByKeyword() {
                const url = window.fdConfig.url.common.searchByKeyword;
                window.fdGlobal.ajax({
                    url: url,
                    method: window.fdConfig.methodGet,
                    params: {
                        keywords: this.search,
                        offset: this.query.offset,
                        size: this.query.limit
                    }
                })
                    .then((res) => {
                        this.data = res.data.data;
                        this.query.total = res.data.total;
                    });
            },
            goToDetail(item) {
                console.log(item);
                if (item.xwGgLb === 'hssp_hsalb') {
                    const query = {bh: item.bh, ejlb: item.gjlb};
                    if (item.c_almk === '0') {
                        query.active = 'hsal';
                    } else if (item.c_almk === '1') {
                        query.active = 'lltt';
                    } else if (item.c_almk === '2') {
                        query.active = 'sptb';
                    } else if (item.c_almk === '3') {
                        query.active = 'flzy';
                    } else if (item.c_almk === '4') {
                        query.active = 'ywsf';
                    } else if (item.c_almk === '5') {
                        query.active = 'hszc';
                    }
                    const url = this.$router.resolve({path: '/lltt/dedail', query: query});
                    window.open(url.href, '_blank');
                } else if (item.xwGgLb === 'hssp_gjfb' ) {
                    const query = {bh: item.bh};
                    let url = '';
                    // 新闻资讯
                    if (item.gjlb === '1') {
                        query.active = 'xwzx';
                        query.fileType = 23;
                        url = this.$router.resolve({path: '/xwzxDetail', query: query});
                    } else if (item.gjlb === '2') {
                        // 法院公告
                        query.active = 'ssfw';
                        query.fileType = 21;
                        url = this.$router.resolve({path: '/xwzxDetail', query: query});
                    } else if (item.gjlb === '3') {
                        // 未上网清单
                        query.active = 'index';
                        query.fileType = 22;
                        url = this.$router.resolve({path: '/xwzxDetail', query: query});
                    } else if (item.gjlb === '5') {
                        // query.active = 'index';
                        query.fileType = 25;
                        url = this.$router.resolve({path: '/xwzxDetail', query: query});
                    } else {
                        // 法院介绍
                        url = this.$router.resolve({path: '/fyjs', query: {tab: 'fyjs', code: item.c_code}});
                    }
                    window.open(url.href, '_blank');
                } else if (item.xwGgLb === 'hssp_zt') {
                    const url = this.$router.resolve({
                        path: '/zt/detail',
                        query: {
                            id: item.bh,
                            fbsj:item.fbsj,
                        }
                    });
                    window.open(url.href, '_blank');
                } else if (item.xwGgLb === 'hssp_kyxx') {
                    const url = this.$router.resolve({path: 'kypm/kyxq', query: {active: 'kypm', tag:'ky', bh: item.c_bh, lx: '20'}});
                    window.open(url.href, '_blank');
                } else if (item.xwGgLb === 'hssp_pmxx') {
                    const url = this.$router.resolve({path: '/kypm/xq', query: {active: 'kypm', tag:'pm', bh: item.c_bh, bdlb: item.c_bdlb, lx: '19'}});
                    window.open(url.href, '_blank');
                }
            },
            pageInformation(pageInfo) {
                this.query.limit = pageInfo.limit;
                this.query.offset = pageInfo.offset;
                this.searchByKeyword();
            }
        }
    };
</script>

<style scoped>

</style>
